import Alpine from 'alpinejs';
import showMore from './showMore.js';

export default (
	endpointProducts,
	endpointDocuments,
	endpointBlogPosts,
	{
		searchPhrase,
		paginatedProducts,
		documentsCount,
		documentGroups,
		paginatedBlogPosts,
		totalSearchCount,
	}
) => ({
	shownSearchPhrase: searchPhrase,
	searchPhrase: searchPhrase,
	paginatedProducts: paginatedProducts,
	documentsCount: documentsCount,
	documentGroups: documentGroups,
	paginatedBlogPosts: paginatedBlogPosts,

	cache: {
		accordionItems: [],
	},

	// Increments when a load starts, and decrements when a load ends. This avoids problems with multiple loading threads
	areProductsLoading: 0,
	areDocumentsLoading: 0,
	areBlogPostsLoading: 0,

	isLoading() {
		return this.areDocumentsLoading || this.areProductsLoading || this.areBlogPostsLoading;
	},

	reload(searchText) {
		const sanitizedSearchText = searchText.replace(/[\s]+/, '+');
		if (searchText.length >= 3) {
			this.$dispatch('pokeshowmore');
			this.areProductsLoading++;
			fetch(`${endpointProducts}?s=${searchText}`, {
				method: 'GET',
			}).then((resp) => {
				if (resp.ok) {
					resp.json().then((json) => {
						this.shownSearchPhrase = searchText;
						this.searchPhrase = sanitizedSearchText;
						this.paginatedProducts = json.data;
					});
				}
				this.areProductsLoading--;
			}).catch((_error) => {
				this.areDocumentsLoading--;
			});
			this.areDocumentsLoading++;
			fetch(`${endpointDocuments}?s=${searchText}`, {
				method: 'GET',
			}).then((resp) => {
				if (resp.ok) {
					resp.json().then((json) => {
						this.documentGroups = json.data.documentGroups;
						this.documentsCount = json.data.documentsCount;
						this.updateAccordionItems();
					});
				}
				this.areDocumentsLoading--;
			}).catch((_error) => {
				this.areDocumentsLoading--;
			});
			this.areBlogPostsLoading++;
			fetch(`${endpointBlogPosts}?s=${searchText}`, {
				method: 'GET',
			}).then((resp) => {
				if (resp.ok) {
					resp.json().then((json) => {
						this.paginatedBlogPosts = json.data;
					});
				}
				this.areBlogPostsLoading--;
			}).catch((_error) => {
				this.areBlogPostsLoading--;
			});
		}
	},

	init() {
		this.updateAccordionItems();
	},

	updateAccordionItems() {
		this.cache.accordionItems = this.documentGroups.map(
			({ name, documents }) => ({
				header: name,
				description: null,
				downloads: documents,
			})
		);
	},

	onInputChanged(e) {
		this.reload(e.target.value);
	},

	totalSearchCount() {
		return this.documentsCount + this.paginatedProducts.pagination.total + this.paginatedBlogPosts.pagination.total;
	},
});
